// SalaDeAula.js
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Container, Row, Col, Card, Button, Nav } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./saladeaula.css?v=3.2.8";
import Turmas from "./components/Turmas.jsx";
import HistoricoChamadas from "./components/HistoricoChamadas.jsx";
import GerenciamentoNotas from "./components/GerenciamentoNotas.jsx";
// import ResumoMaterial from "./components/ResumoMaterial.jsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "./config";

const SalaDeAula = () => {
    const [turmas, setTurmas] = useState([]);
    const [selectedTurma, setSelectedTurma] = useState(null);
    const [alunos, setAlunos] = useState([]);
    const [historicoChamadas, setHistoricoChamadas] = useState([]);
    const [showResumoCard, setShowResumoCard] = useState(false);
    const [selectedChamadaId, setSelectedChamadaId] = useState(null);
    const [activeTab, setActiveTab] = useState("chamadas");

    const navigate = useNavigate();

    useEffect(() => {
        const userType = localStorage.getItem("userType");
        if (userType === "5") {
            navigate("/sala-de-aula-aluno");
        }
    }, [navigate]);


    const carregarTurmas = async () => {
        try {
            const schoolId = localStorage.getItem("schoolId");
            const userId = localStorage.getItem("userId");
            const userType = parseInt(localStorage.getItem("userType"), 10) || 0;
            const response = await axios.get(`${API_BASE_URL}/turmasComAlunos`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const schoolIdNum = parseInt(schoolId, 10);
            const userIdNum = parseInt(userId, 10);

            let filteredTurmas = (Array.isArray(response.data) ? response.data : []).filter(
                (turma) => Number(turma.cp_tr_inativa) !== 1
            );

            if (userType === 4) {
                filteredTurmas = filteredTurmas.filter(
                    (turma) =>
                        turma.cp_tr_id_escola === schoolIdNum &&
                        turma.cp_tr_id_professor === userIdNum
                );
            } else if (userType === 2 || userType === 3) {
                filteredTurmas = filteredTurmas.filter(
                    (turma) => turma.cp_tr_id_escola === schoolIdNum
                );
            } else if (userType !== 1) {
                filteredTurmas = filteredTurmas.filter(
                    (turma) => turma.cp_tr_id_escola === schoolIdNum
                );
            }

            setTurmas(filteredTurmas);
        } catch (error) {
            console.error("Erro ao carregar turmas:", error);
            toast.error("Erro ao carregar turmas. Tente novamente mais tarde.");
        }
    };

    const carregarDadosTurma = async (turmaId) => {
        try {
            const alunosResponse = await axios.get(`${API_BASE_URL}/turmas/${turmaId}/alunos`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setAlunos(alunosResponse.data);

            const chamadasResponse = await axios.get(`${API_BASE_URL}/chamadas/turma/${turmaId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setHistoricoChamadas(chamadasResponse.data);
        } catch (error) {
            console.error("Erro ao carregar dados da turma:", error);
            toast.error("Erro ao carregar dados da turma. Tente novamente mais tarde.");
        }
    };

    const atualizarHistorico = async () => {
        try {
            const chamadasResponse = await axios.get(`${API_BASE_URL}/chamadas/turma/${selectedTurma}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setHistoricoChamadas(chamadasResponse.data);
        } catch (error) {
            console.error("Erro ao atualizar histórico de chamadas:", error);
            toast.error("Erro ao atualizar o histórico. Tente novamente mais tarde.");
        }
    };

    const handleSelectTurma = (turmaId) => {
        setSelectedTurma(turmaId);
        setSelectedChamadaId(null);
        setHistoricoChamadas([]);
        setActiveTab("chamadas");
        carregarDadosTurma(turmaId);
    };

    const handleUpdateStatus = async (chamadaId, status) => {
        try {
            await axios.put(`${API_BASE_URL}/chamadas/${chamadaId}`, {
                status,
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });

            toast.success(`Status atualizado para: ${status}`);
            await atualizarHistorico();
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            toast.error("Erro ao atualizar status. Tente novamente.");
        }
    };

    const handleOpenResumo = (chamadaId) => {
        setSelectedChamadaId(chamadaId);
        setShowResumoCard(true);
    };

    const handleCloseResumo = () => {
        setShowResumoCard(false);
        setSelectedChamadaId(null);
    };

    useEffect(() => {
        carregarTurmas();
    }, []);

    return (
        <div className="sala-de-aula min-vh-100 pb-4">
            <ToastContainer />
            
            {/* Header Section */}
            <div className="p-2">
                <div className="sala-header rounded-3 p-3 shadow-sm mb-2 sala-surface">
                    <div className="d-flex align-items-center gap-3">
                        <div className="sala-header__accent d-flex align-items-center justify-content-center text-white rounded-circle p-2" style={{ width: '48px', height: '48px' }}>
                            <Icon icon="mdi:teach" width="24" />
                        </div>
                        <div>
                            <h2 className="fw-bold mb-0 fs-4">Sala de Aula</h2>
                            <p className="mb-0 text-muted small">Gerencie suas turmas, chamadas e avaliações.</p>
                        </div>
                    </div>
                </div>

                <Turmas turmas={turmas} onSelectTurma={handleSelectTurma} />
            </div>

            {/* Main Content Area */}
            {selectedTurma && (
                <div className="px-2">
                    <div className="rounded-3 shadow-sm sala-surface">
                        <div className="border-bottom">
                            <div className="px-3 pt-3 pb-3">
                                <div className="d-flex gap-3">
                                    <button 
                                        className={`btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold border-0 transition-all nav-pill-custom ${
                                            activeTab === "chamadas" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveTab("chamadas")}
                                    >
                                        <Icon icon="mdi:calendar-check" width="20" />
                                        Chamadas
                                    </button>
                                    <button 
                                        className={`btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold border-0 transition-all nav-pill-custom ${
                                            activeTab === "notas" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveTab("notas")}
                                    >
                                        <Icon icon="mdi:school" width="20" />
                                        Notas e Avaliações
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="">
                            <div className="">
                                {activeTab === "chamadas" && (
                                    <HistoricoChamadas
                                        turmaId={selectedTurma}
                                        historico={historicoChamadas}
                                        alunos={alunos}
                                        onUpdateStatus={handleUpdateStatus}
                                        atualizarHistorico={atualizarHistorico}
                                        onOpenResumo={handleOpenResumo}
                                    />
                                )}

                                {activeTab === "notas" && (
                                    <GerenciamentoNotas
                                        turmaId={selectedTurma}
                                        alunos={alunos}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SalaDeAula;
